<template>
  <div class="new-live-metrics">
    <h2 class="page-title ml-3">
      {{ $t('message.pages.live.metrics.metricsTitle') }}
    </h2>
    <BitrateMetrics class="mb-13" v-bind="$attrs" />
    <FramerateMetrics class="mb-13" v-bind="$attrs" />
    <ViewersMetricsVue v-bind="$attrs" />
  </div>
</template>

<script>
import liveService from '@/services/liveServiceV2'
import BitrateMetrics from './BitrateMetrics.vue'
import FramerateMetrics from './FramerateMetrics.vue'
import ViewersMetricsVue from './ViewersMetrics.vue'

export default {
  name: 'NewLiveV2Metrics',
  components: {
    BitrateMetrics,
    FramerateMetrics,
    ViewersMetricsVue,
  },
  data() {
    return {
      timestampStarted: 0,
    }
  },

  methods: {
    async getMetrics() {
      await liveService.getAnalytics(this.$route.params.id)
    },

    async getLive() {
      const response = await liveService.getLive(this.$route.params.id)
      const dataString = response.data.started_at
      this.timestampStarted = Date.parse(dataString)
    },

    async getInfo() {
      liveService.getInfoHost(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.new-live-metrics {
  font-size: 0.875rem;
  color: var(--v-neutral-lighten1);
}

.bg-dark {
  .new-live-metrics {
    background-color: var(--v-neutral-darken2);
    color: white;
  }

  .page-title {
    color: var(--v-primary-base) !important;
  }
}
</style>
